import React from 'react'
import PropTypes from 'prop-types'
import { redirect } from '@sleepstation/utils'
import { Button, LinkButton } from '@sleepstation/components'
import { SIZE } from '@sleepstation/const'
import { always, assoc, ifElse } from 'ramda'
import { useMutation } from 'urql'
import { CreateInsomniaAssessmentIntent } from '../../../../../graphql/documents'
import useDisplayError from '../../../../../hooks/useDisplayError'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const ERROR_MESSAGE = `There was a problem accessing Sleepstation support`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const modifyCtaButtonBasedOnUserState = ({ canEnrolmentAccessProgramme }) =>
  ifElse(
    always(canEnrolmentAccessProgramme),
    (o) => assoc(`label`, o.labelHasStarted, o),
    (o) => assoc(`label`, o.labelHasNotStarted, o)
  )

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ProgrammeStartLinkButton = ({
  currentEnrolment,
  canEnrolmentAccessProgramme,
  ctaButtonContent,
  dataCyPrefix,
}) => {
  const { displayError } = useDisplayError()

  const [, createInsomniaAssessmentIntent] = useMutation(
    CreateInsomniaAssessmentIntent
  )

  const ctaButton = modifyCtaButtonBasedOnUserState({
    canEnrolmentAccessProgramme,
  })(ctaButtonContent)

  const enrolmentId = currentEnrolment.id

  const handleClick = () => {
    createInsomniaAssessmentIntent({ params: { enrolmentId } }).then(
      ({ error, data }) => {
        if (error) {
          displayError(ERROR_MESSAGE, error, { isFatal: false })
        } else {
          redirect(data.createInsomniaAssessmentIntent.nextPageUrl)
        }
      }
    )
  }

  return canEnrolmentAccessProgramme ? (
    <LinkButton
      href={ctaButton.url}
      size={SIZE.SMALL}
      dataCy={`${dataCyPrefix}-therapy-continue-button`}
    >
      {ctaButton.label}
    </LinkButton>
  ) : (
    <Button
      size={SIZE.SMALL}
      kind="primary"
      onClick={handleClick}
      dataCy={`${dataCyPrefix}-therapy-start-button`}
    >
      {ctaButton.label}
    </Button>
  )
}

ProgrammeStartLinkButton.propTypes = {
  currentEnrolment: PropTypes.object.isRequired,
  canEnrolmentAccessProgramme: PropTypes.bool.isRequired,
  ctaButtonContent: PropTypes.object.isRequired,
  dataCyPrefix: PropTypes.string,
}

ProgrammeStartLinkButton.defaultProps = {
  dataCyPrefix: ``,
}

export default ProgrammeStartLinkButton
